// extracted by mini-css-extract-plugin
module.exports = {"uploader":"Photo__uploader__3n3nf"};